export default __webpack_public_path__ + "static/media/wav.ee9ec4b3.svg";